/* eslint-disable max-len */
import React, { FC, useEffect, useState } from 'react';

// import { useToast } from '@/context/ToastContext';
import { translateGender, translateMonth } from '@/utils/Translator';

import { useEditForm } from '@/context/EditFormContext';
// import BankDataForm from './EditGuestForm/BankDetail';
import { useReservation } from '@/context/ReservationContext';
// import { getBankDetailByIdUser } from '@/services/Bank/request';
// import { BankDetail } from '@/services/Bank/types';
import { useUser } from '@/context/UserContext';

import { FormButton } from '@/components';

import ContactDataForm from './EditGuestForm/Contact';
import PersonalDataForm from './EditGuestForm/Personal';
import {
  CardContainer,
  Container,
  Content,
  FormContainer,
  MediumTextBold,
  SmallText,
  SmallTextBold,
  TitleContainer,
  Wrapper,
} from './styles';

interface Props {
  props?: object;
}

const GuestForm: FC<Props> = () => {
  const { userInformation } = useUser();
  const roles = userInformation?.roles || [];

  // const toast = useToast();
  const { reservationData } = useReservation();
  const { openForm, setOpenForm, formActive, setFormActive } = useEditForm();
  const [openEditForm, setOpenEditForm] = useState(openForm);
  const [activeForm, setActiveForm] = useState(formActive);
  const client = `${reservationData?.guest?.user?.first_name || ''} ${reservationData?.guest?.user?.last_name || ''}`;
  const birthSplitted = reservationData?.guest?.user?.birth_date?.split('/') || '';
  const day = birthSplitted !== '' && birthSplitted[0];
  const month = birthSplitted !== '' && birthSplitted[1];
  const year = birthSplitted !== '' && birthSplitted[2];
  const born = day && month && year ? `${day} de ${translateMonth(month)} de ${year}` : '';
  const phoneNumber1 = reservationData?.guest?.user?.phone_number1 || '';
  const phoneNumber2 = reservationData?.guest?.user?.phone_number2 || '';
  const isIndividual = reservationData?.guest?.user?.is_individual || '';
  const [openPersonalForm, setOpenPersonalForm] = useState<boolean>(false);
  const [openContactForm, setOpenContactForm] = useState<boolean>(false);

  const { gender, email, cpf, cnpj } = reservationData?.guest?.user || '';
  const idNumber = reservationData?.guest?.user.id_number || '';
  const { street, number, neighborhood, complement, city, state, country } =
    reservationData?.guest?.user?.main_address || '';
  const postalCode = reservationData?.guest?.user?.main_address?.postal_code || '';
  const addressGuest = `${street || ''} ${number || ''} ${neighborhood ? `, ${neighborhood}` : ''} ${complement ? ` - ${complement}` : ''} ${city || ''} ${state ? ` - ${state}` : ''} ${country ? ` - ${country}` : ''} ${postalCode ? `, CEP: ${postalCode}` : ''}`;

  // const initialValuesBankDetails = {
  //   id: 0,
  //   entity_name: '',
  //   bank_name: '',
  //   bank_number: '',
  //   branch_number: '',
  //   account_number: '',
  //   account_type: '',
  //   cpf: '',
  //   cnpj: '',
  //   pix_key: '',
  //   user: 0,
  // };

  // const [bankDetail, setBankDetail] = useState<BankDetail>(initialValuesBankDetails);
  // const [accountExists, setAccountExists] = useState<boolean>(false);

  // const getBankDetails = async () => {
  //   try {
  //     const idUser = reservationData?.guest.user.id;
  //     const bank: BankDetail[] = await getBankDetailByIdUser(idUser);
  //     if (bank.length > 0) {
  //       setBankDetail({ ...bank[0] });
  //     } else {
  //       setBankDetail(initialValuesBankDetails);
  //     }
  //     setAccountExists(bank.length > 0);
  //   } catch (e: any) {
  //     toast.alert('Não foi possível recuperar os dados');
  //   }
  // };

  // useEffect(() => {
  //   getBankDetails();
  //   return () => setBankDetail(initialValuesBankDetails);
  // }, []);

  const handleOpenEditForm = (active: number) => {
    if (active === 0) {
      setOpenPersonalForm(true);
      setOpenContactForm(false);
      // setOpenFinanceForm(false);
      setOpenForm(true);
      setFormActive(active);
    } else if (active === 1) {
      setOpenContactForm(true);
      // setOpenFinanceForm(false);
      setOpenPersonalForm(false);
      setOpenForm(true);
      setFormActive(active);
    } else if (active === 2) {
      // setOpenFinanceForm(true);
      setOpenContactForm(false);
      setOpenPersonalForm(false);
      setOpenForm(true);
      setFormActive(active);
    }

    setFormActive(active);
  };

  const resetStatesEditForm = () => {
    setOpenEditForm(false);
    setActiveForm(0);
  };

  useEffect(() => {
    setOpenEditForm(openForm);
    setActiveForm(formActive);
    return () => resetStatesEditForm();
  }, [openForm, formActive]);

  const resetStatesContextEditForm = () => {
    setOpenForm(false);
    setFormActive(0);
  };

  useEffect(() => () => resetStatesContextEditForm(), []);

  return (
    <Container>
      <FormContainer
        onContextMenu={(event): void => {
          event.stopPropagation();
        }}
      >
        <Content>
          <CardContainer>
            <TitleContainer>
              <MediumTextBold>Dados Pessoais</MediumTextBold>
              {!roles.includes('Host') && !openPersonalForm && (
                <FormButton type="button" onClick={() => handleOpenEditForm(0)}>
                  Editar
                </FormButton>
              )}
            </TitleContainer>
            <Wrapper>
              {openEditForm && activeForm === 0 ? (
                <PersonalDataForm
                  reservation={reservationData}
                  activeButton={setOpenPersonalForm}
                />
              ) : (
                <>
                  <SmallTextBold>Nome completo</SmallTextBold>
                  <SmallText>{client}</SmallText>
                  <SmallTextBold>Sexo</SmallTextBold>
                  <SmallText>{translateGender(gender)}</SmallText>
                  <SmallTextBold>Data de nascimento</SmallTextBold>
                  <SmallText>{`${born}`}</SmallText>
                  <SmallTextBold>Tipo de pessoa</SmallTextBold>
                  <SmallText>{`${isIndividual ? 'Física' : 'Jurídica'}`}</SmallText>
                  <SmallTextBold>{`${isIndividual ? 'CPF' : 'CNPJ'}`}</SmallTextBold>
                  <SmallText>{`${isIndividual ? cpf : cnpj}`}</SmallText>
                  <SmallTextBold>Nº de identidade</SmallTextBold>
                  <SmallText>{idNumber}</SmallText>
                </>
              )}
            </Wrapper>
          </CardContainer>

          <CardContainer>
            <TitleContainer>
              <MediumTextBold>Contato</MediumTextBold>
              {!roles.includes('Host') && !openContactForm && (
                <FormButton type="button" onClick={() => handleOpenEditForm(1)}>
                  Editar
                </FormButton>
              )}
            </TitleContainer>
            <Wrapper>
              {openEditForm && activeForm === 1 ? (
                <ContactDataForm
                  email={email}
                  phone1={phoneNumber1}
                  street={street}
                  zipCode={postalCode}
                  number={number}
                  neighborhood={neighborhood}
                  city={city}
                  state={state}
                  country={country}
                  addressExists={reservationData?.guest?.user?.main_address !== null}
                  activeButton={setOpenContactForm}
                />
              ) : (
                <>
                  <SmallTextBold>E-mail</SmallTextBold>
                  <SmallText>{email}</SmallText>
                  <SmallTextBold>Telefone/Celular</SmallTextBold>
                  <SmallText>{`${phoneNumber1} ${phoneNumber2}`}</SmallText>
                  <SmallTextBold>Endereço</SmallTextBold>
                  <SmallText>{addressGuest}</SmallText>
                </>
              )}
            </Wrapper>
          </CardContainer>

          {/* <CardContainer>
            <TitleContainer>
              <MediumTextBold>Dados bancários</MediumTextBold>
              {!roles.includes('Host') && !openFinanceForm && (<FormButton type="button" onClick={() => handleOpenEditForm(2)}>Editar</FormButton>)}
            </TitleContainer>
            <Wrapper>
              {openEditForm && activeForm === 2 ? (
                <BankDataForm
                  id={bankDetail?.id}
                  entityName={bankDetail?.entity_name}
                  bankName={bankDetail?.bank_name}
                  bankNumber={bankDetail?.bank_number}
                  branchNumber={bankDetail?.branch_number}
                  accountNumber={bankDetail?.account_number}
                  accountType={bankDetail?.account_type}
                  cpf={cpf}
                  cnpj={cnpj}
                  pixKey={bankDetail?.pix_key}
                  accountExists={accountExists}
                  user={reservationData?.guest?.user?.id}
                  activeButton={setOpenFinanceForm}
                />
              ) : (
                <>
                  <SmallTextBold>Banco</SmallTextBold>
                  <SmallText>{bankDetail?.bank_name || ''}</SmallText>
                  <SmallTextBold>Titular</SmallTextBold>
                  <SmallText>{client}</SmallText>
                  <SmallTextBold>Conta</SmallTextBold>
                  <SmallText>{`${bankDetail?.bank_number || ''} ${bankDetail?.branch_number || ''} ${bankDetail?.account_number || ''} ${bankDetail?.account_type || ''}`}</SmallText>
                  <SmallTextBold>Pix</SmallTextBold>
                  <SmallText>{bankDetail?.pix_key || ''}</SmallText>
                </>
              )}
            </Wrapper>
          </CardContainer> */}
        </Content>
      </FormContainer>
    </Container>
  );
};

export default GuestForm;
